import { autoinject, bindable, bindingMode, computedFrom } from "aurelia-framework";
import { AppMessageContainer } from "../../services/app-message-container";
import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import * as AppMessage from '../../models/app-message';

@autoinject()
export class AppMessageBar {

    //TODO: Can this be eliminated?
    @bindable({ defaultBindingMode: bindingMode.oneWay }) message: string;

    constructor(
        private appMessageContainer: AppMessageContainer,
        private ea: EventAggregator) {
    }

    @bindable({ defaultBindingMode: bindingMode.oneWay }) containerId: string = "root";
    AppMessage = AppMessage;


    @computedFrom("appMessageContainer.messages.length")
    get messages(): Array<any> {
        return this.appMessageContainer.messages.filter(o => o.containerId == this.containerId);
    }

    subscriptions: Array<Subscription> = [];

    attached() {
        //this.subscriptions.push(this.ea.subscribe(this.appMessageService.events.messages_changed, alert => {
        //    this.adjustBannerPosition();
        //}));
        //this.subscriptions.push(this.ea.subscribe("router:navigation:complete", alert => {
        //    this.adjustBannerPosition();
        //}));
        ////this.appMessageService.alerts = this.appMessageService.alerts;
        //this.adjustBannerPosition();
    }
    detached() {
        while (this.subscriptions.length > 0) {
            this.subscriptions.pop().dispose();
        }
    }

    getAlertClass(type: AppMessage.MessageType) {
        switch (type) {
            case AppMessage.MessageType.info:
                return "info";
            case AppMessage.MessageType.warning:
                return "warning";
            case AppMessage.MessageType.error:
                return "danger";
        }
    }

    adjustBannerPosition() {
        var totalAlertHeight = this.messages.length * ((27 + 5) + 5); //height of alert, including margins
        var pageMarginTop = 50 + totalAlertHeight;
        var bannerPaddingTop = 60 + totalAlertHeight;
        //jQuery("app-message-bar .app-alert").each((i, e) => {
        //    var alertHeight = jQuery(e).outerHeight();
        //    pageMarginTop += alertHeight;
        //    bannerMarginTop += alertHeight;
        //});

        let el: any = document.querySelector(".page.secure");
        el.style.marginTop = pageMarginTop + "px";

        el = document.querySelector(".page.secure .banner")
        el.style.paddingTop = bannerPaddingTop + "px";

    }

    removeMessage(message) {
        var messageIndex = this.appMessageContainer.messages.indexOf(message);
        if (messageIndex > -1) {
            this.appMessageContainer.messages.splice(messageIndex, 1);
        }
        //this.adjustBannerPosition();
    }

}